import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';

import UtilsService from '@/core/services/utils.service';

export interface SettingInterface {
    routeName?: string;
    params?: string;
}

@Mixin
class SettingsMixin extends Vue {
    protected viewSetting: SettingInterface = {};
    protected routeName: string = '';


    public initialize(routeName: string) {
        this.routeName = routeName;
        this.getRouteNameLS(this.routeName);
    }

    protected mounted() {
        if ( this.routeName === '' ) {
            // tslint:disable-next-line:no-console
            console.log('Debe establecer el valor de routeName');
        }
    }


    @Watch('$route.query')
    private watchRouteQuery(newVal: any, oldVal: any) {
        if (
            this.routeName !== '' &&
            !UtilsService.objectIsEmpty(newVal) &&
            !UtilsService.isEquivalent(newVal, oldVal)
        ) {
            const stringified = JSON.stringify(newVal);
            this.setItemLS(this.routeName, stringified);
            this.callbackRouteQueryChange();
        } else if (
            this.routeName !== '' &&
            UtilsService.objectIsEmpty(newVal)
        ) {
            this.getRouteNameLS(this.routeName);
        }
    }

    public callbackRouteQueryChange() {
        // tslint:disable-next-line:no-console
        console.log('callback route query change - implement me!');
    }

    public setItemLS(name: string, value: any) {
        localStorage.setItem(name, value);
    }

    public getItemLS(name: string) {
        return localStorage.getItem(name);
    }

    public getRouteNameLS(routeName: string) {
        const storedItem = this.getItemLS(routeName);
        if ( storedItem !== null ) {
            const jsonParsed = JSON.parse(storedItem);
            if (
                !UtilsService.objectIsEmpty(jsonParsed) &&
                UtilsService.objectIsEmpty(this.$route.query)
            ) {
                this.$router.push({ name: routeName, query: { ...jsonParsed } });
            } else if (
                !UtilsService.objectIsEmpty(this.$route.query)
            ) {
                this.callbackRouteQueryChange();
            }
        } else {
            this.callbackRouteQueryChange();
        }
    }

}

export default SettingsMixin;

